// Maps each appendix module to the team assessment category(ies) that drive
// its highlighted score band, plus the band definitions (shared by the
// on-screen appendix and the PDF). Bands match the report gauges.

export const BANDS = [
  { key: "opportunity", label: "Opportunity", range: "< 60%", color: "#e67e22" },
  { key: "developing", label: "Developing", range: "60–89%", color: "#2B8DCC" },
  { key: "strength", label: "Strength", range: "90% or higher", color: "#69AF45" },
];

// Module index (0-based, matches timAppendix.json order) -> category names.
// M1 (foundational) and M5 (capstone) average two categories.
export const MODULE_CATEGORIES = [
  ["Culture of Trust & Psychological Safety", "Cohesive Commitment"], // M1 Jumpstart
  ["Collaborative Decision-Making"],                                   // M2 Decision-Making
  ["Constructive Conversations"],                                      // M3 Constructive Conversations
  ["Clear Communication Inside and Out"],                              // M4 Communicate Up & Out
  ["Team Performance", "Organizational Support"],                      // M5 Capstone
];

const norm = (s) =>
  (s || "")
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

export const bandKeyForScore = (pct) =>
  pct >= 90 ? "strength" : pct >= 60 ? "developing" : "opportunity";

/**
 * Compute a module's team band from the report's per-category scores.
 * @param {Array<{name:string, positive:number}>} blocksOverallData
 * @param {number} moduleIndex
 * @returns {{ score:number, bandKey:string, categories:string[] }|null}
 */
export const moduleBand = (blocksOverallData, moduleIndex) => {
  const names = MODULE_CATEGORIES[moduleIndex] || [];
  if (!Array.isArray(blocksOverallData) || names.length === 0) return null;
  const vals = names
    .map((n) => {
      const match = blocksOverallData.find((b) => norm(b.name) === norm(n));
      return match ? Number(match.positive) : null;
    })
    .filter((v) => v != null && !Number.isNaN(v));
  if (vals.length === 0) return null;
  const avg = vals.reduce((a, b) => a + b, 0) / vals.length;
  const score = Math.round(avg * 10) / 10;
  return { score, bandKey: bandKeyForScore(avg), categories: names };
};
